import React, { useState, useMemo } from "react";
import { Modal, Button, Row, Col, Card, Badge } from "react-bootstrap";
import { Gem, Star, Rocket } from "lucide-react";
import { loadAuth } from "../libs/authMgmt";
import PlanBadge from "./planBadge";
import { getApiClient } from "../libs/axiosInstance";
import { getSubdomain } from "../libs/helper";
// TODO: point this to your actual helper

export default function PlanManager() {
  const [show, setShow] = useState(false);
  const currentPlan = String(loadAuth("company")?.plan ?? "free").toLowerCase();
  const subdomain = loadAuth("company")?.subdomain ?? "XXX";

  const plans = [
    {
      key: "free",
      label: "Free",
      price: "CA$0",
      icon: <Gem size={22} />,
      features: [ "Basic Reports", "Card Payment", "My Store", "Limited to 10 Products", "Limited AI Prompts (10/day)"],
    },
    {
      key: "pro",
      label: "Pro",
      price: "CA$10.99",
      icon: <Rocket size={22} />,
      features: ["Unlimited Products", "Additional Payment Methods (QR Code)", "Advanced Reports with CSV Export", "Unlimited AI Prompts"],
    },
  ];

  const [isBusy, setBusy] = useState(false);
  const [selectedPlan , setSelectedPlan] = useState(null);

  const isAdmin = loadAuth("role") === "admin";
  if (!isAdmin) return null;


  const handleSelect = (planKey) => {
    // 🔗 hook your upgrade/downgrade flow here (Stripe, API call, etc.)
    // e.g., upgradePlan(planKey).then(()=> setShow(false));
    console.log("Selected plan:", planKey);
    //setShow(false);
    setSelectedPlan(planKey);
    upgradePlan(planKey);
  };

  const date = formatDate(loadAuth("company").subscriptionUntil);

  function formatDate(isoString) {
    const d = new Date(isoString);
  
    return d.toLocaleString("en-US", {
      year: "numeric",
      month: "long",   // full month name
      day: "numeric",
      hour: "numeric",
      minute: "2-digit",
      second: "2-digit",
      hour12: true     // 12h clock with AM/PM
    });
  }

  const stripePrices = {
    //starter: { id: "price_1S22LAJwuZgO17bKPYaPs4Bg" },
    pro: { id: "price_1SSXXOJwuZgO17bKk4LALVIp" },
  };

  
  async function upgradePlan(priceKey) {
    setBusy(true);
    try {
      const r = await getApiClient().post(
        `/api/companies/${subdomain}/billing/checkout`,
        {
          priceId: stripePrices[priceKey].id,
          returnUrl: window.location.href
        }
      );

      const data = r.data;

      if (!data.url) {
        throw new Error("No checkout URL returned");
      }

      window.location.href = data.url;
    } catch (err) {
      console.error("Checkout error:", err);
      alert(`Failed to start checkout: ${err.message}`);
      setBusy(false);
    }
  }
  

  return (
    <>
      <PlanBadge plan={currentPlan} onClick={() => setShow(true)} />

      <Modal show={show} onHide={() => setShow(false)} centered size="lg">
        <Modal.Header closeButton className="border-0 pb-0">
          <Modal.Title>Choose a Plan</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Row className="g-3">
            {plans.map((p) => {
              const isCurrent = p.key === currentPlan;
              return (
                <Col key={p.key} xs={12} md={12/plans.length}>
                  <Card className={`h-100 plan-card border-0 ${p.key === "starter" ? "highlight" : ""}`}>
                    <Card.Body className="text-center">
                      <div className="mb-2 d-inline-flex align-items-center gap-2">
                        {p.icon}
                        <h6 className="fw-semibold mb-0">{p.label}</h6>
                      </div>
                      <div className="display-6 fw-bold mb-2">{p.price}</div>
                      <ul className="small text-start ps-3 mb-3">
                        {p.features.map((f, i) => <li key={i}>{f}</li>)}
                      </ul>

                      {isCurrent ? (
                        <Button variant="outline-primary" className="w-100" disabled>
                          Current
                        </Button>
                      ) : (
                        p.key === "free" && currentPlan === "pro" ? <></> :
                        <Button variant={currentPlan === "pro" ? "danger" : "primary"} className="w-100" onClick={() => handleSelect(p.key)} disabled={isBusy && p.key === selectedPlan}>
                          {isBusy && p.key === selectedPlan ? 
                          <div className="text-start spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                          </div> : ( p.key === "starter" && currentPlan === "pro" ? "Downgrade" : "Upgrade") }
                        </Button>
                      )}
                    </Card.Body>
                  </Card>
                </Col>
              );
            })}
          </Row>
        </Modal.Body>

        <Modal.Footer className="border-0">
          <Badge bg="light" text="dark" className="me-auto text-capitalize">Current: {currentPlan} <span style={{fontWeight:"normal"}}>{currentPlan !== "free" ? "until " + date : ""}</span></Badge>
          <Button variant="light" onClick={() => setShow(false)}>Close</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
